import React from "react";
import { injectIntl } from "react-intl";
import Modal from "../Modal";

import ComposerForm from "./loadable";
import { IProps } from "./interfaces";


export default injectIntl(
    (props: IProps) => (
        <Modal close={props.close}>
            <ComposerForm {...props} />
        </Modal>
    )
);
